/** Display only. Preserve minor-unit values and nonzero cents. */
export function displayMinorAmount(minor:number){
  return (minor<0?'−':'')+'$'+(Math.abs(minor)/100).toFixed(2).replace(/\.00$/,'');
}

/** Format an existing read-model label without changing its stored value. */
export function displayMoneyLabel(label:string){
  return label.replace(/HK\$/g,'$').replace(/(\$\d[\d,]*)\.00\b/g,'$1').replace(/-\$/g,'−$');
}
